var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 26.5122C35.2708 26.0821 34.9204 25.7318 34.4903 25.7318C34.0602 25.7318 33.7095 26.0821 33.7095 26.5122C33.7095 26.9423 34.0602 27.293 34.4903 27.293C34.9204 27.293 35.2708 26.9423 35.2708 26.5122Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 29.6348C35.2708 29.2047 34.9204 28.8544 34.4903 28.8544C34.0602 28.8544 33.7095 29.2047 33.7095 29.6348C33.7095 30.065 34.0602 30.4157 34.4903 30.4157C34.9204 30.4157 35.2708 30.065 35.2708 29.6348Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.587952 1.65427H36.7562V0.799744H0.587952V1.65427Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.587952 4.17638H1.44477V1.65399H0.587952V4.17638Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.587952 5.13484H36.7482V4.17682H0.587952V5.13484Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8309 4.17638H36.7482V1.65399H35.8309V4.17638Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53064 38.8283H3.63504V7.89581H2.53064V38.8283Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0948 38.8366H32.1993V7.90411H31.0948V38.8366Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.189 39.9552V38.8505H2.5481V39.9552H32.189Z",
    stroke: "",
    strokeWidth: 0.412346,
    strokeMiterlimit: 22.9256
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 7.77632C35.2708 7.34621 34.9201 6.99591 34.49 6.99591C34.0595 6.99591 33.7095 7.34621 33.7095 7.77632C33.7095 8.20643 34.0595 8.55718 34.49 8.55718C34.9201 8.55718 35.2708 8.20643 35.2708 7.77632Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 23.3896C35.2708 22.9595 34.9204 22.6091 34.4903 22.6091C34.0602 22.6091 33.7095 22.9595 33.7095 23.3896C33.7095 23.8197 34.0602 24.1705 34.4903 24.1705C34.9204 24.1705 35.2708 23.8197 35.2708 23.3896Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 20.2669C35.2708 19.8368 34.9204 19.4865 34.4903 19.4865C34.0602 19.4865 33.7095 19.8368 33.7095 20.2669C33.7095 20.697 34.0602 21.0478 34.4903 21.0478C34.9204 21.0478 35.2708 20.697 35.2708 20.2669Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 17.1442C35.2708 16.7141 34.9204 16.3638 34.4903 16.3638C34.0602 16.3638 33.7095 16.7141 33.7095 17.1442C33.7095 17.5744 34.0602 17.9251 34.4903 17.9251C34.9204 17.9251 35.2708 17.5744 35.2708 17.1442Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 10.899C35.2708 10.4689 34.9204 10.1185 34.4903 10.1185C34.0602 10.1185 33.7095 10.4689 33.7095 10.899C33.7095 11.3291 34.0602 11.6799 34.4903 11.6799C34.9204 11.6799 35.2708 11.3291 35.2708 10.899Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2708 14.0217C35.2708 13.5916 34.9204 13.2411 34.4903 13.2411C34.0602 13.2411 33.7095 13.5916 33.7095 14.0217C33.7095 14.4518 34.0602 14.8024 34.4903 14.8024C34.9204 14.8024 35.2708 14.4518 35.2708 14.0217Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5811 34.5374H35.3997V32.4589H33.5811V34.5374Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66901 4.17638H3.52508V1.65399H2.66901V4.17638Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2113 4.17638H34.0678V1.65399H33.2113V4.17638Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3277 7.89463V6.78986H2.40894V7.89463H32.3277Z",
    stroke: "",
    strokeWidth: 0.412346,
    strokeMiterlimit: 22.9256
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 6.79022H6.5578V5.13373H5.8219V6.79022Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69916 6.79022H8.4358V5.13373H7.69916V6.79022Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.111 6.79022H29.8469V5.13373H29.111V6.79022Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 6.79022H27.877V5.13373H27.1407V6.79022Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4054 32.5044C35.4054 32.0989 34.9965 31.7681 34.4957 31.7681C33.9949 31.7681 33.5863 32.0989 33.5863 32.5044C33.5863 32.9099 33.9949 33.241 34.4957 33.241C34.9965 33.241 35.4054 32.9099 35.4054 32.5044Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 11.853V10.9323H3.6449V11.853H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 15.903V14.9824H3.6449V15.903H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 19.9537V19.033H3.6449V19.9537H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 24.0041V23.0834H3.6449V24.0041H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 28.0543V27.1336H3.6449V28.0543H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 32.1048V31.1841H3.6449V32.1048H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0854 36.155V35.2343H3.6449V36.155H31.0854Z",
    stroke: "",
    strokeWidth: 0.343559,
    strokeMiterlimit: 22.9256
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 9.31462H6.5578V7.89508H5.8219V9.31462Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 13.1811H6.5578V11.8537H5.8219V13.1811Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 17.2497H6.5578V15.9224H5.8219V17.2497Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 21.2818H6.5578V19.9544H5.8219V21.2818Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 25.3327H6.5578V24.0048H5.8219V25.3327Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 29.3824H6.5578V28.055H5.8219V29.3824Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 33.4696H6.5578V32.1422H5.8219V33.4696Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8219 37.299H6.5578V35.9716H5.8219V37.299Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 9.31462H27.877V7.89508H27.1407V9.31462Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 13.1811H27.8778V11.8537H27.1407V13.1811Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 17.2312H27.8778V15.9037H27.1407V17.2312Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 21.2818H27.8778V19.9544H27.1407V21.2818Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 25.3327H27.8778V24.0048H27.1407V25.3327Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 29.3824H27.8778V28.055H27.1407V29.3824Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 33.4696H27.8778V32.1422H27.1407V33.4696Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1407 37.299H27.8778V35.9716H27.1407V37.299Z",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2386 33.9103H34.7421V33.1959H34.2386V33.9103Z",
    fill: "#FEFEFE",
    stroke: "",
    strokeWidth: 0.460724,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlind);
export default __webpack_public_path__ + "static/media/Blind.afb38c4f08cadbdf385bc22a6f446207.svg";
export { ForwardRef as ReactComponent };